export { SpaEntityError } from './SpaEntityError';
